export default __webpack_public_path__ + "static/media/jogasz.7b7b8242.png";